import React from 'react'
import CookieConsent from "react-cookie-consent";
import { Link } from 'react-router-dom';

export const CookiePolicy = React.memo(() => {
    return (
        <>
            <CookieConsent
                debug={false}
                location="bottom"
                buttonText="Accept"
                declineButtonText="Decline"
                buttonClasses="btn btn-primary"
                enableDeclineButton={true}
                declineButtonClasses="btn btn-secondary"
                buttonWrapperClasses="flex justify-end gap-4"
                containerClasses="fixed p-5 left-auto right-0 w-1/2 rounded-md drop-shadow-xl transition-all z-50"
                disableStyles={true}
                overlay={true}
                cookieName="greytHR-Pro-cookie-policy"
                style={{ background: "#EDF3FF", alignItems: 'center' }}>
                <div className='text-secondary-400 gap-2 flex flex-col w-100'>
                    <span className='text-md font-bold'> Cookies</span>
                    <span className='text-justify text-xs'>
                        This GreytHR-Pro website uses cookies (including Google Ad Manager) and we also use tracking technologies on our website and in emails to improve user experience and provide appropriate information that we may personalize for you. <Link className='underline' to="/static-content?file=privacyPolicy" >Our privacy policy is available here.</Link>
                    </span>
                </div>
            </CookieConsent>
        </>
    )
})

